import { useTranslation } from '@/lib/i18n';
import { presetStrategeQueries, Stratege } from '../Workspace/StrategyLab/strategy-config';

interface StrategyQueryPresetProps {
  onSelect: (query: string) => void;
  strategyType?: Stratege;
}
export default function StrategyQueryPreset(props: StrategyQueryPresetProps) {
  const { onSelect, strategyType } = props;
  const { t } = useTranslation();

  if (strategyType && presetStrategeQueries[strategyType]) {
    return (
      <div className="flex items-center gap-3">
        {Object.entries(presetStrategeQueries[strategyType]).map(([k, v]) => (
          <button
            key={k}
            className="flex items-center px-3 py-1 text-sm border bg-bg-card border-border-card rounded-sm hover:bg-bg-card-hover text-text-secondary"
            onClick={() => onSelect(t(v))}
          >
            {t(k)}
          </button>
        ))}
      </div>
    );
  }
  return null;
}
